import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export function useScrollAnimation() {
  const ref = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '50px 0px 0px 0px' }
    );

    // Observe existing elements
    const observeAll = () => {
      el.querySelectorAll('.fade-in-up:not(.visible)').forEach((node) => {
        io.observe(node);
      });
    };

    observeAll();

    // Watch for lazy-loaded components adding new .fade-in-up elements
    const mo = new MutationObserver(() => observeAll());
    mo.observe(el, { childList: true, subtree: true });

    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, [i18n.language]);

  return ref;
}
